<template>
  <div class="container-fluid container-fluid px-4 rounded-4 contenedor-principal">
    <component :is="gridComponent" :tipoServicio="props.tipoServicio" ref="gridRef" />
  </div>
</template>

<script setup lang="ts">
import { ref, watch, computed } from "vue";
import { getGridComponent } from "@/components/empresas-servicios/ComponentFactory";

const props = defineProps({
  tipoServicio: String
});

const gridRef = ref<any>(null);

const gridComponent = computed(() => {
  return getGridComponent(props.tipoServicio || "");
});

watch(() => props.tipoServicio, () => {
  gridRef.value?.resetGrid();
});

</script>